import { BarChartOutlined } from '@ant-design/icons';
import { AButton, AModal } from '../../../../../components';
import AdvancedFinancialReport from '../../../../../shared/reports/Financial/Advanced';

type TReportKey =
  | 'unified'
  | 'synthetic'
  | 'taxes'
  | 'professionals'
  | 'commissions';

interface IFilterEntry {
  label: string;
  value: string;
}

interface IAdvancedPrintProps {
  open: boolean;
  close: () => void;
  report: {
    reportKey: TReportKey;
    reportLabel: string;
    description: string;
    items: any[];
    summary: Record<string, number>;
    filters: IFilterEntry[];
  };
}

const FinancialAdvancedPrint: React.FC<IAdvancedPrintProps> = ({
  open,
  close,
  report,
}) => {
  return (
    <AModal
      open={open}
      close={close}
      footer={[
        <AButton key="close" type="default" onClick={close}>
          Fechar
        </AButton>,
      ]}
      width={1100}
      title={
        <>
          <BarChartOutlined /> {report.reportLabel}
        </>
      }
    >
      <AdvancedFinancialReport
        reportKey={report.reportKey}
        reportLabel={report.reportLabel}
        description={report.description}
        items={report.items}
        summary={report.summary}
        filters={report.filters}
      />
    </AModal>
  );
};

export default FinancialAdvancedPrint;
